import { RelationshipType } from '@apparatix/schemas/Relationship';

export type SectionConfig = {
  backgroundColor: string;
  color: string;
  icon: string;
  plural: string;
  singular: string;
}

export type ObjectName = 'Activity' | 'Projection';

export const SectionIconography: Record<RelationshipType, SectionConfig> = {
  Account: {
    backgroundColor: '#CCFBF1',
    color: '#14B8A6',
    icon: 'pi pi-building',
    plural: 'Accounts',
    singular: 'Account',
  },
  Contact: {
    backgroundColor: '#FAE8FF',
    color: '#D946EF',
    icon: 'pi pi-id-card',
    plural: 'Contacts',
    singular: 'Contact',
  },
  Document: {
    backgroundColor: '#F3E8FF',
    color: '#A855F7',
    icon: 'pi pi-file',
    plural: 'Documents',
    singular: 'Document',
  },
  Lead: {
    backgroundColor: '#FEF3C7',
    color: '#F59E0B',
    icon: 'pi pi-user-plus',
    plural: 'Leads',
    singular: 'Lead',
  },
  Opportunity: {
    backgroundColor: '#ECFCCB',
    color: '#84CC16',
    icon: 'pi pi-dollar',
    plural: 'Opportunities',
    singular: 'Opportunity',
  },
} as const;

export const ObjectIconography: Record<ObjectName, SectionConfig> = {
  Activity: {
    backgroundColor: '#DBEAFE',
    color: '#3B82F6',
    icon: 'pi pi-calendar',
    plural: 'Activities',
    singular: 'Activity',
  },
  Projection: {
    backgroundColor: '#F1F5F9',
    color: '#94A3B8',
    icon: 'pi pi-chart-bar',
    plural: 'Projections',
    singular: 'Projection',
  },
} as const;

export const SectionIconographyOptions: SectionConfig[] = Object.freeze(
  Object.keys(SectionIconography).map(key => SectionIconography[key]),
);

